import app from './app.js'
import url from './url.js'
import name from './name.js'

const config = Object.assign(
  app,
  url,
  name
)

export default config;
